import ThePage from '@/views/settings/settings'

export default {
  path: '/settings',
  redirect: '/settings/index',
  name: 'settings',
  meta: {
    auth: {
      redirect: {
        name: 'settings.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Definições'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'settings.index',
    component: ThePage,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }]
}
